// Helper to format dates in European format (JJ/MM/AAAA)
export const formatDateEU = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

// Helper to format API error messages (handles Pydantic validation errors)
export const formatError = (e) => {
  const detail = e?.response?.data?.detail;
  if (!detail) return "Erreur serveur";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    // Pydantic validation errors
    return detail.map(err => err.msg || err.message || JSON.stringify(err)).join(", ");
  }
  if (typeof detail === "object") {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return "Erreur inconnue";
};

/**
 * Prix de dégraissage pour un logement, avec fallback.
 * Règle métier :
 *   1) Si `degreasing_price_ttc` > 0 sur le logement → prix configuré (source unique).
 *   2) Sinon si `cleaning_price_ttc` > 0 → prix estimé = cleaning × 1.6 (même règle que "prix conseillé").
 *   3) Sinon aucun montant chiffré (l'équipe doit confirmer).
 *
 * Retour : { price:number|null, source:"configured"|"estimated"|"none", cleaningBase:number }
 * `price` est `null` quand aucune base n'est disponible.
 */
export const computeDegreasingPrice = (property) => {
  const p = property?.pricing || {};
  const configured = Number(p.degreasing_price_ttc || 0);
  if (configured > 0) {
    return { price: configured, source: "configured", cleaningBase: 0 };
  }
  const cleaning = Number(p.cleaning_price_ttc || 0);
  if (cleaning > 0) {
    return { price: Math.round(cleaning * 1.6 * 100) / 100, source: "estimated", cleaningBase: cleaning };
  }
  return { price: null, source: "none", cleaningBase: 0 };
};
